export const getLookingForOptions = (t) => [
    {
        value: 'longTerm',
        label: t('lookingFor.longTerm'),
        icon: '/assets/images/w3tinder/svg/love.svg'
    },
    {
        value: 'longShort',
        label: t('lookingFor.longShort'),
        icon: '/assets/images/w3tinder/svg/smile-emoji.svg'
    },
    {
        value: 'shortLong',
        label: t('lookingFor.shortLong'),
        icon: '/assets/images/w3tinder/svg/toast.svg'
    },
    {
        value: 'shortTerm',
        label: t('lookingFor.shortTerm'),
        icon: '/assets/images/w3tinder/svg/party.svg'
    },
    {
        value: 'newFriends',
        label: t('lookingFor.newFriends'),
        icon: '/assets/images/w3tinder/svg/hello.svg'
    }
];
